import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {firestore} from "../firebase";

const FestivalScore = () => {
  const {state} = useLocation();
  const navigate = useNavigate();

  const {level, docId} = state; // 전달받은 정보

  const [info, setInfo] = useState(null);
  const [score, setScore] = useState("");

  useEffect(() => {
    const load = async () => {
      const ref = doc(firestore, `Festival_${level}`, docId);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setInfo({id: snap.id, ...snap.data()});
      }
    };
    load();
  }, [level, docId]);

  const saveScore = async () => {
    const ref = doc(firestore, `Festival_${level}`, docId);

    await updateDoc(ref, {
      score: Number(score),
      updatedAt: new Date(),
    });

    alert("점수 등록 완료!");
    navigate("/festival-list");
  };

  if (!info) return <div className="p-4">불러오는 중...</div>;

  return (
    <div className="container py-4" style={{maxWidth: "500px"}}>

      <h3 className="mb-4 fw-bold">점수 등록</h3>

      <p><strong>이름:</strong> {info.name}</p>
      <p><strong>이메일:</strong> {info.email}</p>
      <p><strong>전화번호:</strong> {info.phone}</p>

      <div className="mb-3">
        <label className="form-label">점수 입력 *</label>
        <input
          type="number"
          className="form-control"
          value={score}
          onChange={(e) => setScore(e.target.value)}
        />
      </div>

      <button className="btn btn-primary w-100" onClick={saveScore}>
        저장
      </button>
    </div>
  );
};

export default FestivalScore;
